// This file is auto-generated by @hey-api/openapi-ts
import { client } from './client.gen';
export class TestService {
    /**
     * Test endpoint to verify API is running
     */
    static getTest(options) {
        return (options?.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/test',
            ...options
        });
    }
}
export class ProjectsService {
    /**
     * List projects with filtering, sorting, and pagination
     */
    static list(options) {
        return (options?.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects',
            ...options
        });
    }
    /**
     * Get available filter options for the projects list
     */
    static getFilterOptions(options) {
        return (options?.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/filter-options',
            ...options
        });
    }
    /**
     * List the roles the project members panel offers, and which the caller may assign
     */
    static getAssignableProjectRoles(options) {
        return (options.client ?? client).get({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}/assignable-roles',
            ...options
        });
    }
    /**
     * List role assignments for a project
     */
    static getProjectRoleAssignments(options) {
        return (options.client ?? client).get({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}/role-assignments',
            ...options
        });
    }
    /**
     * Delete a published project by platform project ID
     */
    static deleteProject(options) {
        return (options.client ?? client).delete({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}',
            ...options
        });
    }
    /**
     * Get a published project by platform project ID
     */
    static getProjectById(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}',
            ...options
        });
    }
    /**
     * Update a published project by platform project ID
     */
    static updateProject(options) {
        return (options.client ?? client).patch({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Replace the full member set of a published project
     */
    static updateProjectMembers(options) {
        return (options.client ?? client).put({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}/members',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Resolve a project id to its owning workspace and organization
     *
     * Accepts the internal project id or the platform project id, regardless of the selected workspace. Reveals organization identity only to members of that organization.
     */
    static resolveWorkspace(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{id}/resolve-workspace',
            ...options
        });
    }
}
export class DraftProjectsService {
    /**
     * Create a draft project to get a project.id for the intake flow
     */
    static createDraft(options) {
        return (options?.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/drafts',
            ...options
        });
    }
    /**
     * Delete a draft project
     */
    static deleteDraft(options) {
        return (options.client ?? client).delete({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/drafts/{id}',
            ...options
        });
    }
    /**
     * Get a draft project by ID
     */
    static getDraftById(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/drafts/{id}',
            ...options
        });
    }
    /**
     * Update a draft project by ID
     */
    static updateDraft(options) {
        return (options.client ?? client).patch({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/drafts/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Promote a draft project to a full project with Platform creation
     */
    static publishDraft(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/drafts/{id}/publish',
            ...options
        });
    }
    /**
     * Request a presigned URL to upload a file to a draft project
     */
    static requestUpload(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/drafts/{id}/files/request-upload',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Confirm a file version upload for a draft project
     */
    static confirmUpload(options) {
        return (options.client ?? client).post({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/drafts/{id}/files/{fileId}/versions/{versionId}/confirm',
            ...options
        });
    }
}
export class ProjectFilesService {
    /**
     * Request a presigned URL for file upload
     */
    static requestUpload(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}/files/request-upload',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Check whether a set of file names would lead to a collision (conflict in a folder)
     *
     * Runs a pre-upload validation to check which file names would lead to conflict on a folder
     */
    static checkNameConflicts(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}/files/check-name-conflicts',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Request a presigned URL for uploading a new file version
     */
    static requestVersionUpload(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}/files/{fileId}/request-version-upload',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * List uploaded project files with filtering, sorting, and pagination
     */
    static listFiles(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}/files',
            ...options
        });
    }
    /**
     * Delete a project file
     */
    static deleteFile(options) {
        return (options.client ?? client).delete({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}/files/{fileId}',
            ...options
        });
    }
    /**
     * Get a project file by ID
     */
    static getFile(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}/files/{fileId}',
            ...options
        });
    }
    /**
     * Update project file metadata (name, tags)
     */
    static updateFile(options) {
        return (options.client ?? client).patch({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}/files/{fileId}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Confirm that a file version has been uploaded
     */
    static confirmUpload(options) {
        return (options.client ?? client).post({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}/files/{fileId}/versions/{versionId}/confirm',
            ...options
        });
    }
    /**
     * List versions of a project file
     */
    static listVersions(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}/files/{fileId}/versions',
            ...options
        });
    }
    /**
     * Delete a specific file version
     */
    static deleteVersion(options) {
        return (options.client ?? client).delete({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}/files/{fileId}/versions/{versionId}',
            ...options
        });
    }
    /**
     * Get a specific version of a project file
     */
    static getVersion(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}/files/{fileId}/versions/{versionId}',
            ...options
        });
    }
    /**
     * Update the review status of a project file
     */
    static updateFileStatus(options) {
        return (options.client ?? client).patch({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}/files/{fileId}/status',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Move a file to a different folder
     */
    static moveFile(options) {
        return (options.client ?? client).patch({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}/files/{fileId}/folder',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class ProjectFoldersService {
    /**
     * List folders in a project with filtering, sorting, and pagination
     */
    static listFolders(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}/folders',
            ...options
        });
    }
    /**
     * Create a new folder in a project
     */
    static createFolder(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}/folders',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Delete a folder and its empty subfolders (soft delete)
     */
    static deleteFolder(options) {
        return (options.client ?? client).delete({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}/folders/{folderId}',
            ...options
        });
    }
    /**
     * Get a folder by ID
     */
    static getFolderById(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}/folders/{folderId}',
            ...options
        });
    }
    /**
     * Rename a folder
     */
    static updateFolder(options) {
        return (options.client ?? client).patch({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}/folders/{folderId}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Get the download manifest for a folder subtree
     *
     * Returns the flat list of every downloadable asset under the folder (including nested subfolders). The FE feeds this list to the assets-api zip-stream endpoint.
     */
    static getFolderDownloadManifest(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}/folders/{folderId}/download-manifest',
            ...options
        });
    }
    /**
     * Set or clear the folder thumbnail override
     *
     * Set `assetId` to a project file id inside the folder subtree to pin that asset as the thumbnail. Pass `null` to revert to auto-seeded resolution (oldest uploaded asset in subtree).
     */
    static setFolderThumbnail(options) {
        return (options.client ?? client).patch({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}/folders/{folderId}/thumbnail',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Set the chain new uploads into a folder are put on
     *
     * Set `workflowId` to an approval chain of the project, or `null` so new uploads get none. Assets already in the folder keep their chain. `includeSubfolders` applies the same chain to every subfolder below.
     */
    static setFolderAutoApplyWorkflow(options) {
        return (options.client ?? client).patch({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}/folders/{folderId}/auto-apply-workflow',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class ProjectArtifactsService {
    /**
     * List artifacts attached to a project
     */
    static list(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}/artifacts',
            ...options
        });
    }
    /**
     * Attach one or more artifacts to a project
     *
     * Re-attaching an artifact already attached to the project is a no-op: the existing row is returned unchanged and any folderId in the request is ignored. To relocate an attached artifact, detach and re-attach it.
     */
    static attach(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}/artifacts',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Detach a project_artifact row from a project (soft-delete by link-row id)
     */
    static detach(options) {
        return (options.client ?? client).delete({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}/artifacts/{projectArtifactId}',
            ...options
        });
    }
    /**
     * List live attachment IDs for a project
     *
     * Returns only the `artifact_id`s of currently-attached (non-soft-deleted) rows. Use this from the FE picker to compute the "already attached" disabled set without paging the full attachment list.
     */
    static listIds(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}/artifacts/ids',
            ...options
        });
    }
    /**
     * Get a single Library row enriched with preview payload
     *
     * Returns the list-shape DTO extended with `data` (widget payload), `description` (live from api with snapshot fallback), and `mimeType` (for file/upload kinds). Used by the Library artifact preview modal to mount the correct renderer per kind.
     */
    static getDetail(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}/artifacts/{artifactId}/detail',
            ...options
        });
    }
    /**
     * Export a brief artifact as a PDF document
     *
     * Renders the `data.brief` snapshot of a `brief-generation-widget:v1` artifact through the same pdfmake renderer the entity-backed brief export uses. Only this artifact key is exportable; other kinds (including `social-brief-widget:v1`) are rejected with a 4xx.
     */
    static export(options) {
        return (options.client ?? client).get({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}/artifacts/{artifactId}/export',
            ...options
        });
    }
    /**
     * Bulk-resolve Library rows enriched with preview payload
     *
     * POST sibling of `GET :artifactId/detail` that resolves many ids in one round-trip, reusing the same resolution + auth/ownership. `details` preserves the order of the request `ids`; ids that resolve to no live row are silently omitted.
     */
    static getDetails(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}/artifacts/detail',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class TagsService {
    /**
     * Search tags by name
     */
    static search(options) {
        return (options?.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tags',
            ...options
        });
    }
    /**
     * Create a tag
     */
    static create(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tags',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class CommentsService {
    /**
     * Request a presigned upload URL for a comment attachment
     *
     * Records a pending claim tying the resulting assetId to the caller, then returns a presigned S3 POST URL. The returned assetId must be sent back in CreateCommentDto.attachmentAssetIds (or UpdateCommentDto.attachmentAssetIds) to bind the upload to a comment.
     */
    static requestAttachmentUpload(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}/comments/attachments/request-upload',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * List comments for a project target
     */
    static listByTarget(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}/comments',
            ...options
        });
    }
    /**
     * Create a comment on a project target
     */
    static create(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}/comments',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * List every active comment annotation for a target
     *
     * Returns all non-deleted root-comment annotations (id + annotation) for the target, independent of comment pagination. The editor hydrates text highlights from this so annotations on not-yet-loaded comment pages still render.
     */
    static listAnnotations(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}/comments/annotations',
            ...options
        });
    }
    /**
     * Delete a comment (soft delete)
     */
    static delete(options) {
        return (options.client ?? client).delete({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}/comments/{commentId}',
            ...options
        });
    }
    /**
     * Get a comment by ID
     */
    static getById(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}/comments/{commentId}',
            ...options
        });
    }
    /**
     * Update a comment
     */
    static update(options) {
        return (options.client ?? client).patch({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}/comments/{commentId}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Resolve or unresolve a root comment
     *
     * Set the resolution status of a root comment. Any caller with project write access can flip the status — not just the author. resolvedBy/resolvedAt are derived from the authenticated caller and server clock; replies cannot be resolved.
     */
    static updateStatus(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}/comments/{commentId}/status',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class ProjectBriefsService {
    /**
     * List briefs for a project
     */
    static list(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}/briefs',
            ...options
        });
    }
    /**
     * Create a new brief
     */
    static create(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}/briefs',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Get activity log for a brief
     */
    static getActivity(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}/briefs/{briefId}/activity',
            ...options
        });
    }
    /**
     * Export a brief as a PDF document
     */
    static export(options) {
        return (options.client ?? client).get({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}/briefs/{briefId}/export',
            ...options
        });
    }
    /**
     * Soft-delete a brief
     */
    static delete(options) {
        return (options.client ?? client).delete({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}/briefs/{briefId}',
            ...options
        });
    }
    /**
     * Get a brief by ID
     */
    static getById(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}/briefs/{briefId}',
            ...options
        });
    }
    /**
     * Update a brief
     */
    static update(options) {
        return (options.client ?? client).patch({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}/briefs/{briefId}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Sync a brief's sections against its source template's current state
     */
    static reconcileTemplate(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}/briefs/{briefId}/actions/reconcile-template',
            ...options
        });
    }
    /**
     * Submit a brief for review
     */
    static submit(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}/briefs/{briefId}/submit',
            ...options
        });
    }
}
export class WorkflowDefinitionsService {
    /**
     * List workflow definitions for a project
     */
    static list(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}/workflows',
            ...options
        });
    }
    /**
     * Create a new workflow definition
     */
    static create(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}/workflows',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * List the project roles an approval chain step may name
     */
    static listStepRoles(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}/workflows/step-roles',
            ...options
        });
    }
    /**
     * Soft-delete a workflow definition
     */
    static delete(options) {
        return (options.client ?? client).delete({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}/workflows/{workflowId}',
            ...options
        });
    }
    /**
     * Get a workflow definition by ID
     */
    static getById(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}/workflows/{workflowId}',
            ...options
        });
    }
    /**
     * Update a workflow definition (full replace)
     */
    static update(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}/workflows/{workflowId}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Duplicate a workflow definition within the same project
     */
    static duplicate(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}/workflows/{workflowId}/duplicate',
            ...options
        });
    }
    /**
     * Copy a workflow definition from another project (structure only, no assignees)
     */
    static copyFrom(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}/workflows/copy-from/{sourceProjectId}/{sourceWorkflowId}',
            ...options
        });
    }
}
export class AssetWorkflowAssignmentService {
    /**
     * Remove workflow from an asset
     */
    static remove(options) {
        return (options.client ?? client).delete({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}/assets/{assetId}/workflow',
            ...options
        });
    }
    /**
     * Get asset's workflow assignment and approval progress
     */
    static getProgress(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}/assets/{assetId}/workflow',
            ...options
        });
    }
    /**
     * Assign a workflow to an asset
     *
     * A different workflow replaces the one currently assigned, discarding the approvals collected against it.
     */
    static assign(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}/assets/{assetId}/workflow',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class BulkWorkflowAssignmentService {
    /**
     * Bulk assign workflow to multiple assets
     */
    static bulkAssign(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}/workflows/{workflowId}/assign',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Bulk remove workflow from multiple assets
     */
    static bulkUnassign(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}/workflows/{workflowId}/unassign',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class AssetApprovalActionsService {
    /**
     * Get asset's step-by-step approval progress
     */
    static getApprovalProgress(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}/assets/{assetId}/approval-progress',
            ...options
        });
    }
    /**
     * Approve asset at a step — its current step in order, or the named step in any order
     */
    static approve(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}/assets/{assetId}/approval-progress/approve',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Unapprove asset at a step. In order this rewinds to the target step and resets it plus every subsequent step; in any order it clears only the named step.
     */
    static unapprove(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}/assets/{assetId}/approval-progress/unapprove',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Override a step as a manager. The step is satisfied outright whatever its threshold, and the reviewer approvals already on it are left untouched.
     */
    static overrideStep(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}/assets/{assetId}/approval-progress/override',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Undo a step override as a manager. Only the override is removed; the reviewer approvals on that step survive, and an in-order chain resets the steps after it.
     */
    static undoStepOverride(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}/assets/{assetId}/approval-progress/undo-override',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Bulk approve multiple assets by a single step. In order that is the current step; in any order it is the lowest open step assigned to the caller, or simply the lowest open step for an admin. Repeat the call to walk the rest of the chain.
     */
    static bulkApprove(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}/assets/bulk-approve',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Bulk unapprove multiple assets
     */
    static bulkUnapprove(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/projects/{platformProjectId}/assets/bulk-unapprove',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class TrackersBoardLayoutService {
    /**
     * Get the current workspace's shared Trackers board layout (column order/widths, group order, etc.). Returns an object with all fields null if no row exists yet.
     */
    static get(options) {
        return (options?.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/trackers-board-layout',
            ...options
        });
    }
    /**
     * Upsert the current workspace's shared Trackers board layout. Full-replace; last-write-wins.
     */
    static upsert(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/trackers-board-layout',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class TrackersService {
    /**
     * List every tracker of the caller's organization they can open, oldest first.
     *
     * Unpaged, and superseded by `GET /organization-trackers`, which pages the same trackers. With a workspace header, the default boards are provisioned in that workspace first.
     */
    static list(options) {
        return (options?.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/trackers',
            ...options
        });
    }
    /**
     * Create a tracker in the caller's organization, private unless `visibility` says otherwise.
     */
    static create(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/trackers',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Delete a tracker and all of its items.
     */
    static delete(options) {
        return (options.client ?? client).delete({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/trackers/{trackerId}',
            ...options
        });
    }
    /**
     * Get a tracker (including its board layout).
     */
    static getById(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/trackers/{trackerId}',
            ...options
        });
    }
    /**
     * Update a tracker (name/description; layout is full-replace when provided).
     *
     * Anyone who can edit the board may change its layout and grouping, as long as the custom columns stay the same. Changing those, or any other field, is for the board's owner or an organization admin.
     */
    static update(options) {
        return (options.client ?? client).patch({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/trackers/{trackerId}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * List a tracker's members. Who else opens it follows its `visibility`.
     */
    static listMembers(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/trackers/{trackerId}/members',
            ...options
        });
    }
    /**
     * Replace a tracker's members; the owner is kept. Never changes its `visibility`.
     */
    static updateMembers(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/trackers/{trackerId}/members',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * List a tracker's items in board order.
     */
    static listItems(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/trackers/{trackerId}/items',
            ...options
        });
    }
    /**
     * Add an item to a tracker (appended at the end). Rejected on a record-backed board, which has no items of its own.
     */
    static createItem(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/trackers/{trackerId}/items',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Incremental change-feed of a tracker's items (for external sync).
     *
     * Returns rows created or updated at/after your current position, ordered oldest-change first, with a keyset `nextCursor` for the next page. First call: pass `updatedSince` (or nothing to backfill from the beginning). Subsequent calls: pass the `nextCursor` from the previous page. When `nextCursor` is null you are caught up — resume later with the last non-null cursor. UPSERTS ONLY: deletions are not represented here; receive them via webhooks or reconcile periodically.
     */
    static listItemsDelta(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/trackers/{trackerId}/items/delta',
            ...options
        });
    }
    /**
     * Delete an item from a tracker. Rejected on a record-backed board, which has no items of its own.
     */
    static deleteItem(options) {
        return (options.client ?? client).delete({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/trackers/{trackerId}/items/{itemId}',
            ...options
        });
    }
    /**
     * Update an item (title/position; customColumnValues is full-replace, customColumnValuesPatch changes only the cells it names). Rejected on a record-backed board, which has no items of its own.
     */
    static updateItem(options) {
        return (options.client ?? client).patch({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/trackers/{trackerId}/items/{itemId}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Page a record-backed board's rows, filtered, sorted and counted in the database.
     *
     * For boards whose `itemSource` is a record type (`projects`, `assets`) rather than free text. Rows are the source records themselves, resolved against the caller's access on every request, so a record they cannot see never appears. `fields` holds the read-only source values and `customColumnValues` the board's own columns; both can be filtered, sorted and counted on, custom columns under a `custom.<columnId>` name. `total` and `valueCounts` are computed over the whole matching set, not the page, so a group count equals the rows paging that group would yield. Boards with any other source return 400.
     */
    static listRows(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/trackers/{trackerId}/rows',
            ...options
        });
    }
    /**
     * The caller's stored workspace scope for a record-backed board.
     *
     * A personal view setting: which workspaces the rows route reads when it is given no `scope`. An empty `workspaceIds` means every workspace the caller can read. `resolvedWorkspaceIds` is what it resolves to right now, falling back to every readable workspace when none of the stored ones is; `available` lists every workspace the caller can read, and `locked` is true when that is only one. When no workspace can be read: 503 `scope_unavailable` if some did not answer, 403 `scope_forbidden` if every one refused the caller. A board whose rows are not records, or a briefs board, returns 400 `scope_not_supported`.
     */
    static getScope(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/trackers/{trackerId}/scope',
            ...options
        });
    }
    /**
     * Store the caller's workspace scope for a record-backed board.
     *
     * Needs only read access to the board: the scope changes what the caller sees, never the board. The ids are stored as sent, empty for every readable workspace, and intersected with what the caller can read on every request. A board whose rows are not records, or a briefs board, returns 400 `scope_not_supported`.
     */
    static updateScope(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/trackers/{trackerId}/scope',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Set a row's board-owned column values, the source record's own fields, or both.
     *
     * `customColumnValues` patches the board's own map key by key and never reaches the record; send it as null to clear the row outright. `fields` writes through to the record itself, through the same endpoint and the same edit permission its own screens use, and is limited to the few fields each source allows. A row the caller cannot see returns 404; a field they may not write, or that no source allows, returns 403 or 400 with nothing stored.
     */
    static updateRow(options) {
        return (options.client ?? client).patch({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/trackers/{trackerId}/rows/{rowKey}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * AI-suggest dashboard widgets from a board profile (columns + distributions).
     */
    static suggestDashboard(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/trackers/{trackerId}/dashboard-suggestion',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Per-row comment counts for a board (one badge query, not one per row).
     */
    static listCommentCounts(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/trackers/{trackerId}/comment-counts',
            ...options
        });
    }
    /**
     * List a board row's comments (by rowKey).
     *
     * Where the row IS a record that carries a comment thread of its own, an asset or a brief, these are that record's comments: the same ones its own page shows.
     */
    static listComments(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/trackers/{trackerId}/comments',
            ...options
        });
    }
    /**
     * Add a comment to a board row.
     */
    static createComment(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/trackers/{trackerId}/comments',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Delete a board row comment.
     *
     * On a board whose rows it owns, the author, the tracker owner or an admin may delete. On a row that IS a record the comment lives in the record's own thread, so the record's rule applies instead and only the author may take it down.
     */
    static deleteComment(options) {
        return (options.client ?? client).delete({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/trackers/{trackerId}/comments/{commentId}',
            ...options
        });
    }
    /**
     * Edit a board row comment (author only) or settle/reopen it (anyone).
     */
    static updateComment(options) {
        return (options.client ?? client).patch({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/trackers/{trackerId}/comments/{commentId}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * List a board's automation rules.
     */
    static listAutomations(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/trackers/{trackerId}/automations',
            ...options
        });
    }
    /**
     * Create an automation rule.
     */
    static createAutomation(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/trackers/{trackerId}/automations',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Stream a board's events while a page has it open.
     *
     * Server-sent events. `ready` arrives once the stream is subscribed to the board; until then, or if the stream errors instead, the page cannot count on hearing results. `automation.run` names a row the automation rules just finished with and the columns they wrote, so the page re-reads that row; `rowsChanged` says a rule added, moved or archived a row, so the page re-reads the board. `heartbeat` keeps an idle stream open. `close` ends the stream: the viewer can no longer open the board, or the stream reached its lifetime cap; the page reconnects as after any drop and is authorised again. Delivery is best effort; a page catches up on its next read.
     */
    static streamEvents(options) {
        return (options.client ?? client).get({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/trackers/{trackerId}/events',
            ...options
        });
    }
    /**
     * Read back what a board's automation rules did, newest first.
     *
     * One entry per rule per row change it matched: what it wrote and whether that changed the row. Filter by rule with `automationId` or by row with `rowRef`. Entries are kept for 30 days, and outlive a deleted rule. Rows the caller cannot see are left out.
     */
    static listAutomationRuns(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/trackers/{trackerId}/automation-runs',
            ...options
        });
    }
    /**
     * List the agents the caller may run from a rule on this board, a page at a time.
     *
     * Agents of every workspace whose people the caller is offered, each with its workspace, ordered by workspace name. A rule names the agent with `agentId` and `agentWorkspaceId`.
     */
    static listAvailableAgentsForBoard(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/trackers/{trackerId}/available-agents',
            ...options
        });
    }
    /**
     * Delete an automation rule.
     */
    static deleteAutomation(options) {
        return (options.client ?? client).delete({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/trackers/{trackerId}/automations/{automationId}',
            ...options
        });
    }
    /**
     * Update an automation rule (toggle, reorder, or edit).
     */
    static updateAutomation(options) {
        return (options.client ?? client).patch({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/trackers/{trackerId}/automations/{automationId}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Try a rule, saved or not, against the board without changing anything.
     *
     * Counts the rows a run now would change and returns a sample of them with each value before and after. With `rowRef`, also says what the rule would do to that row were it to fire there; `row` is null when the board no longer shows that row to the caller.
     */
    static previewAutomation(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/trackers/{trackerId}/automations/actions/preview',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Have AI propose a rule for this board from a sentence, without saving it.
     *
     * The proposal passes the same checks a saved rule does and comes back to be confirmed; creating it is a separate call to the create endpoint. A proposal that fails a check is refused with 422 `automation_proposal_invalid` and its `problems`; a sentence that describes no rule, with 422 `automation_proposal_not_understood`; a model answer that could not be read as a rule, with 422 `automation_proposal_malformed`. The call counts against the workspace's monthly AI budget, including one whose answer could not be read.
     */
    static proposeAutomation(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/trackers/{trackerId}/automations/actions/propose',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Rules suggested by the board's own habits, strongest first.
     *
     * Found daily from the cell edits people made by hand in the last two weeks: a pair of edits (change A, then set B) seen on at least five rows, following at least 60% of the times A changed that way. Heuristic. Nothing is created from a suggestion until a person saves it in the builder.
     */
    static listAutomationSuggestions(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/trackers/{trackerId}/automation-suggestions',
            ...options
        });
    }
    /**
     * Turn a suggested rule down; the same pattern is not offered again.
     */
    static dismissAutomationSuggestion(options) {
        return (options.client ?? client).post({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/trackers/{trackerId}/automation-suggestions/{suggestionId}/actions/dismiss',
            ...options
        });
    }
    /**
     * Take a suggested rule to the builder. Creates nothing.
     *
     * Returns the rule to open in the builder; it exists once a person saves it there.
     */
    static acceptAutomationSuggestion(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/trackers/{trackerId}/automation-suggestions/{suggestionId}/actions/accept',
            ...options
        });
    }
    /**
     * List rows to try a rule on.
     *
     * The rows of the board as the caller's board shows them, with their titles, narrowed by `search`. Capped at 50; `hasMore` says a narrower search would reach more.
     */
    static listAutomationPreviewRows(options) {
        return (options.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/trackers/{trackerId}/automation-preview-rows',
            ...options
        });
    }
    /**
     * Run a rule on the rows that already match it, or count them.
     *
     * Applies the rule to every row already in the state its trigger names and passing its conditions, on which its actions would change something. A dry run (the default) only counts those rows. The rule must be switched on.
     */
    static runAutomation(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/trackers/{trackerId}/automations/{automationId}/actions/run',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Read the organization's monthly AI budget and what its boards spent this month, across every workspace.
     */
    static getOrganizationAiBudget(options) {
        return (options?.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/organizations/current/ai-budget',
            ...options
        });
    }
    /**
     * Set the organization's monthly AI budget.
     *
     * Applies at once, to calls not yet started, on every board of the organization; once the month to date reaches it, AI actions fail, visibly in the run history, until it is raised or the month turns (UTC).
     */
    static updateOrganizationAiBudget(options) {
        return (options.client ?? client).put({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/organizations/current/ai-budget',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Read the organization's monthly AI budget from one of its workspaces.
     *
     * Use `GET /organizations/current/ai-budget`.
     *
     * @deprecated
     */
    static getAiBudget(options) {
        return (options?.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/workspaces/current/ai-budget',
            ...options
        });
    }
    /**
     * Which AI rule actions this workspace can offer the person asking.
     */
    static getAiCapabilities(options) {
        return (options?.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/workspaces/current/ai-capabilities',
            ...options
        });
    }
    /**
     * The workspace agents the person asking may run from a rule.
     *
     * Only agents an automation can run are listed: ones with tools, knowledge bases or outside services are left out. Empty when `api` cannot answer. Superseded by `GET /trackers/{trackerId}/available-agents`, which lists agents across workspaces.
     *
     * @deprecated
     */
    static listAvailableAgents(options) {
        return (options?.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/workspaces/current/available-agents',
            ...options
        });
    }
    /**
     * List the trackers of the caller's organization
     *
     * Public trackers, and private ones the caller owns or is a member of; every tracker for an organization admin. Never creates starter boards.
     */
    static listOrganizationTrackers(options) {
        return (options?.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/organization-trackers',
            ...options
        });
    }
    /**
     * List the people a tracker can be shared with
     *
     * The members of the workspaces the caller can read; of every workspace of the organization for an organization admin. Deduplicated and sorted by name.
     */
    static listTrackerPeople(options) {
        return (options?.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tracker-people',
            ...options
        });
    }
}
export class WebhooksService {
    /**
     * List the organization's webhook subscriptions (admin only).
     */
    static list(options) {
        return (options?.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/webhooks',
            ...options
        });
    }
    /**
     * Create a webhook subscription (admin only).
     *
     * Registers an endpoint to receive one tracker board's events. The response includes the signing `secret` — this is the ONLY time it is returned; store it to verify delivery signatures.
     */
    static create(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/webhooks',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Delete a webhook subscription (admin only).
     */
    static delete(options) {
        return (options.client ?? client).delete({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/webhooks/{subscriptionId}',
            ...options
        });
    }
    /**
     * Update a webhook subscription (admin only).
     */
    static update(options) {
        return (options.client ?? client).patch({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/webhooks/{subscriptionId}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class TrackerTemplatesService {
    /**
     * List the templates the caller can reuse.
     *
     * Returns every organization-visible template, workspace templates in the current workspace, and the caller’s own private templates. Product/default templates are added by the frontend catalog and are not included here.
     */
    static list(options) {
        return (options?.client ?? client).get({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tracker-templates',
            ...options
        });
    }
    /**
     * Save a tracker as a reusable template (structure only, no rows).
     *
     * Snapshots the source tracker’s item source, grouping, and layout. The caller must have access to the source tracker.
     */
    static create(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tracker-templates',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Delete a template (owner or admin).
     */
    static delete(options) {
        return (options.client ?? client).delete({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tracker-templates/{templateId}',
            ...options
        });
    }
    /**
     * Update a template’s name/description/visibility/icon/colour (owner or admin).
     */
    static update(options) {
        return (options.client ?? client).patch({
            responseType: 'json',
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/v1/tracker-templates/{templateId}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
export class AgentsService {
    /**
     * Run an agent to completion and return its output.
     */
    static run(options) {
        return (options.client ?? client).post({
            responseType: 'json',
            url: '/api/v1/agents/{agentId}/run',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    /**
     * Run an agent and stream its output as server-sent events.
     */
    static stream(options) {
        return (options.client ?? client).post({
            url: '/api/v1/agents/{agentId}/stream',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
